import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";

const AddLeadeBoard = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();
  const parmas = useParams();

  const location = useLocation();
  // Check if the current route matches the desired route path

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    // let type = "";
    // if (location.pathname === `/admin/academic/addacademicsub/${parmas?.id}`) {
    //   type = "board";
    // } else if (location.pathname === `/admin/academic/class/${parmas.id}`) {
    //   type = "class";
    // } else if (location.pathname === `/admin/academic/subject/${parmas.id}`) {
    //   type = "subject";
    // } else {
    //   type = "academic";
    // }
    // form.append("title", type);

    // You can adjust the header configuration according to your API requirements
    academicModal
      .createAcademic(form)
      .then((response) => {
        // console.log(response.data, "fqAdd");
        helper.sweetalert.toast("Your Ads add.", "success");
        if (
          location.pathname === `/admin/academic/addacademicsub/${parmas?.id}`
        ) {
          navigate(`/admin/board/${parmas?.id}`);
        } else if (location.pathname === `/admin/academic/class/${parmas.id}`) {
          navigate(`/admin/class/${parmas.id}`);
        } else if (
          location.pathname ===
          `/admin/academic/subject/${parmas.id}/${"subject"}`
        ) {
          navigate(`/admin/subjectaca/${parmas.id}`);
        } else {
          navigate(`/admin/academic`);
        }
        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error.response?.data?.message.logo[0],"errorll")
        helper.sweetalert.toast(
          error.response?.data?.message.logo[0],
          "warning"
        );
        // console.log(error);
      });
  };

  console.log(parmas.name, "locatiosdffs");

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  <span>Add Leader Board</span>
                </h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail"> Title </Label>
                          <Input
                            id="name"
                            name="name"
                            placeholder="Enter Name"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                        <Label for="exampleEmail">Leader 1</Label>
                        <Input id="forType" name="forType" type="select">
                        <option value="driver">Select Option</option>
                            <option value="High">Raju (7890765432)</option>
                            <option value="Medium">Raj (7890765432)</option>
                            <option value="Low">Yash (7890765432)</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                        <Label for="exampleEmail">Leader 2</Label>
                        <Input id="forType" name="forType" type="select">
                            
                        <option value="driver">Select Option</option>
                            <option value="High">Raju (7890765432)</option>
                            <option value="Medium">Raj (7890765432)</option>
                            <option value="Low">Yash (7890765432)</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Leader 3</Label>
                          <Input id="forType" name="forType" type="select">
                            
                            <option value="driver">Select Option</option>
                            <option value="High">Raju (7890765432)</option>
                            <option value="Medium">Raj (7890765432)</option>
                            <option value="Low">Yash (7890765432)</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        color="secondary"
                        onClick={() => {
                          navigate("/admin/studentleadboard");
                        }}
                      >
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{
                            float: "right",
                            marginLeft: "5%",
                            backgroundColor: "#080278",
                            color: "white",
                            border: "none",
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddLeadeBoard;
